import { Table } from '@vwfs-bronson/bronson-react';
import { Environment } from '../fes';

function formatVersions(versions: Environment['versions']): string {
  return versions.length > 0 ? versions.join(', ') : '-';
}

export function EnvironmentsTable({ environments }: { environments: Environment[] }) {
  if (environments.length === 0) {
    return <p className="app-empty">No environments found.</p>;
  }

  return (
    <div className="app-table-wrap">
      <Table className="app-table" colored>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Versions</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {environments.map(environment => (
            <Table.Tr key={environment.environmentId || environment.name}>
              <Table.Td>{environment.name}</Table.Td>
              <Table.Td>{formatVersions(environment.versions)}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
}
